module.exports = __webpack_public_path__ + "img/9.906ac7d1.png";